import { connect } from 'react-redux';
import {
  getCarouselCurrentSlideIsDark,
  getCarouselSlideCount,
  getCarouselSlideDuration,
  getCarouselSlideIndex,
  getSliceActiveMenuIndex,
  getSliceIsEdgeToEdge,
  isCarouselPaused,
  isCarouselVideoPlaying,
} from '../../selectors';
import { carouselPausedCreator, carouselSlideChangedCreator } from '../../actions';

const mapStateToProps = (state, { sliceId: carouselId }) => {
  const isVideoPlaying = isCarouselVideoPlaying(state, carouselId);
  const isMenuOpen = getSliceActiveMenuIndex(state, carouselId) >= 0;
  const slideIndex = getCarouselSlideIndex(state, carouselId);
  const slideCount = getCarouselSlideCount(state, carouselId);
  return {
    carouselId,
    edgeToEdge: getSliceIsEdgeToEdge(state, carouselId),
    isCarousel: slideCount > 1,
    isDark: getCarouselCurrentSlideIsDark(state, carouselId),
    isPaused: isVideoPlaying ? true : (isMenuOpen || isCarouselPaused(state, carouselId)),
    slideCount,
    slideDuration: getCarouselSlideDuration(state, carouselId),
    slideIndex,
  };
};

const mapDispatchToProps = (dispatch, { sliceId: carouselId }) => ({
  onCarouselPaused: () => dispatch(carouselPausedCreator(carouselId)),
  onSlideChange: slideIndex => dispatch(carouselSlideChangedCreator(carouselId, slideIndex)),
});

export default connect(mapStateToProps, mapDispatchToProps);
